import { useTranslation } from 'react-i18next';
import { advantages } from '@/mocks/homeData';

export default function AdvantagesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            {t('home.advantages.title')}
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('home.advantages.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {advantages.map((adv) => (
            <div
              key={adv.id}
              className="text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="text-4xl md:text-5xl font-bold text-accent-500 mb-2">
                {adv.value}
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">
                {adv.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {adv.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}